import React from 'react';
import { useTranslation } from 'react-i18next';
import { NowPlayingLayout } from '../layout';
import { useAppSelector, useAppDispatch } from '../../../../../store/store';
import { uiActions } from '../../../../../store/slices/ui';

import QueueSongDetailsProps from './SongDetails';
import ReactDragListView from 'react-drag-listview';
import { playerService } from '../../../../../services/player';
import { motion, AnimatePresence } from 'framer-motion';

const NowPlaying = () => {
  const [t] = useTranslation(['playingBar']);
  const song = useAppSelector(
    (state) => state.spotify.state?.track_window.current_track,
    (a, b) => a?.id === b?.id
  );
  if (!song) return null;

  return (
    <div>
      <p className='playing-section-title'>{t('Now playing')}</p>
      <div style={{ margin: 5 }}>
        <QueueSongDetailsProps song={song} isPlaying={true} />
      </div>
    </div>
  );
};

const Queueing = () => {
  const [t] = useTranslation(['playingBar']);
  const queue = useAppSelector(
    (state) => state.queue.queue,
    (a, b) => {
      if (a === b) return true;
      if (!a || !b) return false;
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) {
        if (a[i].id !== b[i].id) return false;
      }
      return true;
    }
  );

  if (!queue || !queue.length) return null;

  const onDragEnd = (fromIndex: number, toIndex: number) => {
    playerService.reorderUpcomingQueue(fromIndex, toIndex);
  };

  return (
    <div style={{ marginTop: 30 }}>
      <p className='playing-section-title'>{t('Next')}</p>

      <ReactDragListView
        nodeSelector=".queue-item-wrapper"
        onDragEnd={onDragEnd}
        lineClassName="drag-line-green"
      >
        <div style={{ margin: 5 }}>
          <AnimatePresence>
            {queue.map((q: any, i: number) => (
              <motion.div
                key={q.uid || q.id + '-' + i}
                layout
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ type: "spring", stiffness: 400, damping: 30 }}
                className="queue-item-wrapper"
                style={{ cursor: 'grab' }}
              >
                <QueueSongDetailsProps song={q} isPlaying={false} queueIndex={i} />
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </ReactDragListView>
    </div>
  );
};

export const Queue = () => {
  const [t] = useTranslation(['playingBar']);
  const dispatch = useAppDispatch();

  return (
    <NowPlayingLayout title={t('Queue')} onClose={() => dispatch(uiActions.collapseQueue())}>
      <div style={{ marginTop: 20 }}>
        <NowPlaying />
        <Queueing />
      </div>
    </NowPlayingLayout>
  );
};
